import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import AddProvider from "./addProviders";
import EditProvider from "./editProvider";
import {
  MODAL_HEADER_STYLE,
  MODAL_SUBMIT_BTN_CLASS,
  MODAL_SUBMIT_BTN_STYLE,
  MODAL_CANCEL_BTN_CLASS,
} from "./ProviderSettingsModal";
import "../../styles/tailwind.css";

export const PROVIDER_ADD_FORM_ID = "provider-add-form";

export const getProviderEditFormId = (providerId) =>
  `provider-edit-form-${providerId}`;

function ProviderAddEditModal({
  show,
  mode,
  providerId,
  onClose,
  onSuccess,
}) {
  const [saving, setSaving] = useState(false);
  const isAdd = mode === "add";
  const title = isAdd ? "Add New Provider" : "Edit Provider";
  const formId = isAdd
    ? PROVIDER_ADD_FORM_ID
    : getProviderEditFormId(providerId);
  const submitLabel = saving
    ? isAdd
      ? "Creating..."
      : "Updating..."
    : isAdd
      ? "Create"
      : "Update";

  useEffect(() => {
    if (!show) {
      setSaving(false);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      scrollable
      size="xl"
      backdropClassName="!z-[1040]"
      className="provider-add-edit-modal !z-[1050]"
      dialogClassName="provider-add-edit-modal-dialog !my-1 !max-w-7xl !w-[calc(100%-1rem)]"
      contentClassName="!flex !min-h-[88vh] !max-h-[96vh] !flex-col !overflow-hidden !rounded-xl !border !border-gray-200 !bg-white !shadow-xl"
    >
      <Modal.Header
        closeButton={false}
        className="!flex shrink-0 items-center justify-between !border-0 px-4 py-3"
        style={MODAL_HEADER_STYLE}
      >
        <Modal.Title className="!mb-0 text-lg font-bold text-white">
          {title}
        </Modal.Title>
        <button
          type="button"
          onClick={onClose}
          disabled={saving}
          className="border-0 bg-transparent text-2xl leading-none text-white transition hover:text-white/90 disabled:opacity-60"
          aria-label="Close"
        >
          &times;
        </button>
      </Modal.Header>

      <Modal.Body className="!min-h-[calc(88vh-7rem)] !max-h-[calc(96vh-7rem)] !flex-1 overflow-y-auto px-4 py-4">
        {isAdd ? (
          <AddProvider
            key="provider-add-form"
            embedded
            formId={PROVIDER_ADD_FORM_ID}
            onSuccess={onSuccess}
            onCancel={onClose}
            onSavingChange={setSaving}
          />
        ) : (
          <EditProvider
            key={`provider-edit-form-${providerId}`}
            embedded
            formId={getProviderEditFormId(providerId)}
            providerId={providerId}
            onSuccess={onSuccess}
            onCancel={onClose}
            onSavingChange={setSaving}
          />
        )}
      </Modal.Body>

      <Modal.Footer className="shrink-0 border-t border-gray-100 px-4 py-3">
        <button
          type="button"
          onClick={onClose}
          disabled={saving}
          className={MODAL_CANCEL_BTN_CLASS}
        >
          Cancel
        </button>
        <button
          type="submit"
          form={formId}
          disabled={saving}
          className={MODAL_SUBMIT_BTN_CLASS}
          style={MODAL_SUBMIT_BTN_STYLE}
        >
          {submitLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProviderAddEditModal;
